function parseSubmissionNumber(value, parser = Number) {
  if (value == null) return null;

  if (typeof value === "string" && value.trim() === "") {
    return null;
  }

  const parsedValue = parser(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
}

export function normalizeTakeProfitSubmission(takeProfit, takeProfitMode, parser = Number) {
  const nextMode = String(takeProfitMode || "None");

  if (nextMode === "None") {
    return { takeProfit: null, takeProfitMode: "None" };
  }

  const parsedTakeProfit = parseSubmissionNumber(takeProfit, parser);

  if (parsedTakeProfit === 0) {
    return { takeProfit: null, takeProfitMode: "None" };
  }

  return {
    takeProfit: parsedTakeProfit,
    takeProfitMode: nextMode,
  };
}
